import PartialRateViewPage from '../containers/Rate/ParialLoad/View/PartialRateView';  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const Express = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <PartialRateViewPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Express
